export const getBrowserType = () => {
  const ua = navigator.userAgent.toLowerCase();

  if (ua.includes("edg")) return "edge";
  if (ua.includes("chrome") && !ua.includes("opr")) return "chrome";
  if (ua.includes("firefox")) return "firefox";
  if (ua.includes("safari") && !ua.includes("chrome")) return "safari";

  return "unknown";
};

export const openNotificationSettings = () => {
  const browser = getBrowserType();

  switch (browser) {
    case "chrome":
      window.open("chrome://settings/content/notifications", "_blank");
      break;

    case "edge":
      window.open("edge://settings/content/notifications", "_blank");
      break;

    case "firefox":
      alert(
        "Firefox does not allow opening notification settings automatically.\n\n" +
        "Go to: Settings → Privacy & Security → Notifications → Settings"
      );
      break;

    case "safari":
      alert(
        "Safari does not allow opening notification settings automatically.\n\n" +
        "Go to: Safari → Settings → Websites → Notifications"
      );
      break;

    default:
      alert(
        "Please open your browser settings and allow notifications for this site."
      );
  }
};
